import { ENVIRONMENT_BASE_URL_API } from '@configs/environment';

const LOG_THROTTLE_MS = 60 * 1000;
const sentLogCache = new Map();

/**
 * Sends client diagnostic logs silently to backend server.
 * Does not show anything on the client UI.
 */
export const sendServerLog = async ({
  level = 'error',
  screen = 'unknown',
  eventId = null,
  userInviteId = null,
  action = 'check-in',
  message = '',
  details = '',
}) => {
  try {
    // Throttle: cùng một lỗi chỉ gửi tối đa 1 lần / 60 giây
    const throttleKey = `${screen}|${action}|${typeof message === 'string' ? message : ''}`;
    const now = Date.now();
    if (sentLogCache.has(throttleKey) && now - sentLogCache.get(throttleKey) < LOG_THROTTLE_MS) {
      return;
    }
    if (sentLogCache.size > 200) sentLogCache.clear();
    sentLogCache.set(throttleKey, now);

    const payload = {
      level,
      screen,
      eventId: eventId ? Number(eventId) : null,
      userInviteId: userInviteId ? String(userInviteId) : null,
      action,
      message: typeof message === 'string' ? message : JSON.stringify(message),
      details: typeof details === 'string' ? details : JSON.stringify(details),
    };

    const apiUrl = `${ENVIRONMENT_BASE_URL_API}/MstCheckinout/client-log`;

    if (typeof fetch !== 'undefined') {
      fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => {
        // Silently ignore network failures for logging
      });
    }
  } catch (e) {
    // Never throw from logger
  }
};
